export default {"src":"/_next/static/media/hilNodata.5f5d7cf0.svg","height":250,"width":250};